import {UseQueryResult} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {LIMS_SAMPLING_POINTS_QUERY_KEY} from '../../api/queries/getLimsSamplingPoints'
import {LimsSamplingPoint} from '../../types'

import {useSettingsQuery} from '@settings/modules/common/providers'
import {useUrlParam} from '@settings/modules/routing'

export function useLimsSamplingPointsQuery(): UseQueryResult<LimsSamplingPoint[]> {
  const plantCode = useUrlParam('plantCode')
  const {t} = useTranslation()

  return useSettingsQuery(LIMS_SAMPLING_POINTS_QUERY_KEY, [plantCode], {
    meta: {
      errorMessage: t('samplingPointsSettings.queries.fetchLimsSamplingPointsError')
    }
  })
}
